import moment from "moment";
import "moment/locale/de";
/**
 * Simple throttle function that executes a passed function only once in the specified timeout
 * @param handlerFunc
 * @param [timeout] the throttle interval
 */
export default {
  getMomentDate(date) {
    return moment(date)
  },
  formatDate(date, withTime, format="DD.MM.YYYY") {
    let myDate = new Date(date);
    let resDate = moment(myDate).format(format);
    if (withTime) resDate += " - " + this.formatTime(date); // moment(myDate).format("HH:mm");
    return resDate;
  },
  formatTime(date) {
    return moment(date).format("HH:mm");
  },
  addDays(date, mDays) {
    let newDate = new Date(date);
    return (new Date(newDate.setDate(newDate.getDate()+mDays)));
  },
  addMonths(date, mMonths) {
    debugger
    let newDate = moment(newDate);
    console.log(newDate.add(mMonths, 'M'));
    return (new Date(newDate.add(mMonths, 'M')));
    // return (new Date(newDate.setDate(date.getDate()+mDays)));
  },
  startDayOfMonth(date) {
    return moment(new Date(date)).startOf('month').format("YYYY-MM-DD");
  },
  lastDayOfMonth(date) {
    return moment(new Date(date)).endOf('month').format("YYYY-MM-DD");
  },
  startDayOfPreviousMonth(date, months=1) {
    return moment(new Date(date)).subtract(months, 'months').startOf('month').format("YYYY-MM-DD");
  },
  lastDayOfPreviousMonth(date, months=1) {
    return moment(new Date(date)).subtract(months, 'months').endOf('month').format("YYYY-MM-DD");
  },
  startDayOfNextMonth(date, months=1) {
    return moment(new Date(date)).add(months, 'months').startOf('month').format("YYYY-MM-DD");
  },
  lastDayOfNextMonth(date, months=1) {
    return moment(new Date(date)).add(months, 'months').endOf('month').format("YYYY-MM-DD");
  },
  getOnlyDay(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  },
  getOnlyDayIsoString(date) {
    return moment(date).format("YYYY-MM-DD");
  },
  isDateBetweenRange(dateToCheck, start, end) {
    const a = moment(start, "DD/MM/YYYY");
    const b = moment(end, "DD/MM/YYYY");
    const compare = moment(this.getOnlyDay(dateToCheck), "DD/MM/YYYY");

    return compare.isBetween(a, b) || compare.isSame(a) || compare.isSame(b);
  },
  dateFromNow(date) {
    return moment(date).fromNow();
  },
  formatMonth(date) {
    return moment(date).format("MMM");
  },
  getDay(date) {
    return moment(date).format("dddd");
  },
  formatTimeWithSeconds(value) {
    if (value == null) {
      return null;
    }
    let seconds = value % 60;
    value = Math.floor(value / 60);
    let minutes = value % 60;
    value = Math.floor(value / 60);
    let hours = value;
    let pad = i => ("0" + i).substr(-2);
    return (hours > 0 ? hours + ":" : "") + pad(minutes) + ":" + pad(seconds);
  },
  formatFromToDate(from, to) {
    // check if we want to display also the time?
    var s = new Date(from);
    var e = new Date(to);
    if (s.toDateString() == e.toDateString()) {
      if (s.toLocaleTimeString() == e.toLocaleTimeString()) {
        return this.formatDate(from) + " " + this.formatTime(from);
      } else {
        return this.formatDate(from); // +       " " +       this.formatTime(from) +     " - " +   this.formatTime(to)
      }
    } else {
      return (
        this.formatDate(from) +
        // " " +
        // this.formatTime(from) +
        " - " +
        this.formatDate(to)
        // " " +
        // this.formatTime(to)
      );
    }
  },

  formatS2M: value => {
    if (value == null) {
      return null;
    }
    let seconds = value % 60;
    value = Math.floor(value / 60);
    let minutes = value % 60;
    value = Math.floor(value / 60);
    let hours = value;
    let pad = i => ("0" + i).substr(-2);
    return (hours > 0 ? hours + ":" : "") + pad(minutes) + ":" + pad(seconds);
  },
  formatM2Km: meter => {
    if (meter<100) return meter + " m";
    return Math.round(meter / 10) / 100 + " km";
  },
  // calculate minutes for a kilometer
  calMin4Km(durationInSeconds, distanceInMeters) {
    return ((durationInSeconds||0)/60/(distanceInMeters||0)*1000)
  },
  formatPace(min4km = null, postValue=" m/km") {
    return (
      Math.floor(min4km) +
      ":" +
      Math.round((min4km - Math.floor(min4km)) * 60) +
      postValue
    );
  },
  formatSpeed2Pace: s4m => {
    return 1000 / s4m / 60;
  },
  formatSpeed(s4m = null, postValue= " km/h") {
    return ((s4m * 60 * 60) / 1000).toFixed(2) + postValue;
  },
  roundDown(labelValue) {
    return Math.abs(Number(labelValue)) >= 1.0e+9
        ? Math.abs(Number(labelValue)) / 1.0e+9 + "B"
        : Math.abs(Number(labelValue)) >= 1.0e+6
            ? Math.abs(Number(labelValue)) / 1.0e+6 + "M"
            : Math.abs(Number(labelValue)) >= 1.0e+3
                ? Math.abs(Number(labelValue)) / 1.0e+3 + "K"
                : Math.abs(Number(labelValue));
  }
};
